import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["name", "type", "categories", "duration", "badge", "onClick", "href", "thumbnailUrl", "to"];
import { getDisplayCategories } from 'academy-common-lib/utils/categories';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Badge } from 'foundations-components/transitional/components/Badge';
import { resize } from 'FileManagerCore/utils/resize';
import usageTracker from '../../../utils/usageTracker';
import ACContentCardLarge from 'academy-common-lib/components/card/ACContentCardLarge';
import { getReactRouterHref } from '../../../utils/urls';
import { jsx as _jsx } from "react/jsx-runtime";
const BADGE_MESSAGES = {
  POPULAR: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "academyCommon.contentCard.badge.popular"
  }),
  NEW: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "academyCommon.contentCard.badge.new"
  }),
  UPDATED: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "academyCommon.contentCard.badge.updated"
  })
};
const PublicContentCard = _ref => {
  let {
      name,
      type,
      categories,
      duration,
      badge,
      onClick,
      href,
      thumbnailUrl,
      to
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const resizedThumbnailUrl = thumbnailUrl ? resize(thumbnailUrl, {
    length: 400
  }) : undefined;
  return /*#__PURE__*/_jsx(ACContentCardLarge, Object.assign({
    contentHref: to || href ? getReactRouterHref(href) : undefined,
    contentType: type,
    imageSrc: resizedThumbnailUrl || '',
    length: duration || 0,
    lengthType: "time",
    linkMode: "react-router",
    name: name,
    onLinkClick: () => {
      usageTracker.track('interaction', {
        action: 'click-content-card',
        value: href
      });
      onClick === null || onClick === void 0 || onClick();
    },
    ribbonText: badge && BADGE_MESSAGES[badge],
    ribbonUse: badge === 'NEW' ? 'new' : 'koala',
    tags: getDisplayCategories(categories).map(categoryKey => /*#__PURE__*/_jsx(FormattedMessage, {
      message: `academyCommon.categories.${categoryKey}`
    }, categoryKey))
  }, restProps));
};
export default PublicContentCard;